import { useCallback } from "react";
import { useAppDispatch } from "../ducksHook";
import {
  authActions
} from "../slices/auth.slice";

// Types
import { userActions } from "../slices/user.slice";
import { LoginInput, SessionValue, SignupInput } from "../types";

type AuthServiceOperators = {
  onLogout: () => void;
  onResetLoading: () => void;
  onSignin: (params: LoginInput) => void;
  onSignInWithFB: (params: string) => void;
  onSignInWithGoogle: (params: string) => void;
  onUpdateProfile: (params: SignupInput) => void;
  onTermsAndConditionChange: (params: boolean) => void;
  updateUserRewards: (params: any) => void;
  onLoginSuccess: (params: SessionValue) => void;
  onRefreshTokenUpdate: (params: SessionValue) => void;
};

export const useAuthService = (): Readonly<AuthServiceOperators> => {
  const dispatch = useAppDispatch();

  return {
    onSignin: useCallback(
      (params: any) => {
        dispatch(authActions.loginRequest(params));
      },
      [dispatch]
    ),
    onSignInWithFB: useCallback(
      (params: string) => {
        dispatch(authActions.loginFBRequest(params));
      },
      [dispatch]
    ),
    onSignInWithGoogle: useCallback(
      (params: string) => {
        dispatch(authActions.loginGoogleRequest(params));
      }, [dispatch]
    ),
    onLogout: useCallback(() => {
      dispatch(authActions.logout());
    }, [dispatch]),
    onResetLoading: useCallback(() => {
      dispatch(authActions.resetLoading());
    }, [dispatch]),
    onUpdateProfile: useCallback((params: SignupInput) => {
      dispatch(userActions.updateProfile(params));
    }, [dispatch]),
    onTermsAndConditionChange: useCallback((params: boolean) => {
      dispatch(authActions.termsAndCondition(params));
    }, [dispatch]),
    updateUserRewards: useCallback((params: any) => {
      dispatch(userActions.updateUserRewards(params));
    }, [dispatch]),
    onLoginSuccess: useCallback((params) => {
      dispatch(authActions.loginSuccess(params));
    }, [dispatch]),
    onRefreshTokenUpdate: useCallback((params) => {
      dispatch(authActions.refreshToken(params));
    }, [dispatch]),
  };
};

export default useAuthService;
